<div class="relative">
  @if (elements) {
    <div [class.popover-open]="popover" [formGroup]="parentForm">
      <mobi-ui-typeahead-major
        #postalCityTypeahead
        class="postal_city"
        [formControlName]="postalCityId"
        [id]="postalCityId"
        name="postal_city"
        [aria-label]="
          'wfa_postal_city_label'
            | texts
              : {
                  context: 'primcalc',
                  default: 'Postleitzahl oder Ort',
                }
        "
        [placeholder]="
          'wfa_postal_city_label'
            | texts
              : {
                  context: 'primcalc',
                  default: 'Postleitzahl oder Ort',
                }
        "
        [value]="values.postal_city"
        [required]="
          hidden || !field['#required']
            ? false
            : elements.postal_code['#required'] || elements.city['#required']
        "
        (searchTermChange)="values['postal_city'] = $event"
        (valueChanges)="handleChange('postal_city', $event)"
        [autoSelectFirstOrMatch]="true"
        autocomplete="off"
      >
        @for (location of postalCity$ | async; track location) {
          <mobi-ui-typeahead-option-major [value]="location">
            {{ location }}
          </mobi-ui-typeahead-option-major>
        }
      </mobi-ui-typeahead-major>
      <div class="relative">
        <mobi-ui-typeahead-major
          #addressTypeahead
          class="address"
          [formControlName]="addressId"
          [id]="addressId"
          name="street"
          [loading]="loading.address"
          [aria-label]="elements.address['#title']"
          [placeholder]="elements.address['#placeholder'] || elements.address['#title']"
          [value]="values.address"
          [required]="
            hidden || !field['#required'] ? false : elements.address['#required']
          "
          (searchTermChange)="values['address'] = $event"
          (valueChanges)="handleChange('address', $event)"
          [autoSelectFirstOrMatch]="true"
          autocomplete="off"
        >
          @for (address of address$ | async; track address) {
            <mobi-ui-typeahead-option-major [value]="address">
              {{ address }}
            </mobi-ui-typeahead-option-major>
          }
        </mobi-ui-typeahead-major>
        <mobi-ui-input-major
          class="address_2"
          [formControlName]="address2Id"
          [id]="address2Id"
          name="building"
          [loading]="loading.address_2"
          [aria-label]="elements.address_2['#title']"
          [placeholder]="
            elements.address_2['#placeholder'] || elements.address_2['#title']
          "
          [value]="values.address_2"
          [required]="
            hidden || !field['#required'] ? false : elements.address_2['#required']
          "
          (valueChange)="handleChange('address_2', $event)"
          autocomplete="off"
        />
      </div>
    </div>
  }
  <div [hidden]="!popover" class="mobi-ui-popover-bottom">
    <mobi-ui-popover-major #addressPopover>
      <p
        class="mobi-ui-font-italic mobi-ui-font-tisa mobi-ui-text-center mobi-ui-font-size-100 mobi-ui-margin-b-xxs"
      >
        {{
          'address_not_found'
            | texts
              : {
                  context: 'errors',
                  default: 'nicht gefunden, meinten Sie:',
                }
        }}
      </p>

      @if (alternativeAddresses?.length) {
        @for (
          address of alternativeAddresses;
          track address.streetName + address.houseNo
        ) {
          <div class="mobi-ui-card-silent is-clickable is-row is-small ng-star-inserted">
            <mobi-ui-icon-major class="suggestions-icon" name="location_pin" size="md" />
            <button class="pl-[6px] pr-[20px] text-left" (click)="setAddress(address)">
              {{ address.zipCode }}&nbsp;{{ address.townName }}
              <br />
              {{ address.streetName }}&nbsp;{{ address.houseNo
              }}{{ address.houseNoAddition }}
            </button>
          </div>
        }
      }
    </mobi-ui-popover-major>
  </div>
</div>
<div class="errors">
  @for (key of [postalCityId, addressId, address2Id]; track key) {
    @if (parentForm.get(key)?.hasError('required') && parentForm.get(key)?.touched) {
      <mobi-ui-form-message-major level="error">
        @if (key === postalCityId) {
          {{
            'wfa_postal_city_required'
              | texts
                : {
                    context: 'errors',
                    default: 'Bitte geben Sie eine Postleitzahl und einen Ort ein.',
                  }
          }}
        }
        @if (key === addressId) {
          {{
            'wfa_address_required'
              | texts
                : {
                    context: 'errors',
                    default: 'Bitte geben Sie eine Strasse ein.',
                  }
          }}
        }
        @if (key === address2Id) {
          {{
            'wfa_building_number_required'
              | texts
                : {
                    context: 'errors',
                    default: 'Bitte geben Sie eine Hausnummer ein.',
                  }
          }}
        }
      </mobi-ui-form-message-major>
    }
    @if (
      key === postalCityId &&
      parentForm.get(key)?.hasError('invalidPostalCity') &&
      !parentForm.get(key)?.hasError('xssContent') &&
      !parentForm.get(key)?.hasError('required') &&
      parentForm.get(key)?.touched
    ) {
      <mobi-ui-form-message-major level="error">
        {{
          'wfa_postal_city_invalid'
            | texts
              : {
                  context: 'errors',
                  default: 'Diese Kombination aus Postleitzahl und Ort existiert nicht.',
                }
        }}
      </mobi-ui-form-message-major>
    }
    @if (
      key === postalCityId &&
      parentForm.get(key)?.hasError('incompletePostalCity') &&
      !parentForm.get(key)?.hasError('invalidPostalCity') &&
      !parentForm.get(key)?.hasError('xssContent') &&
      !parentForm.get(key)?.hasError('required') &&
      parentForm.get(key)?.touched
    ) {
      <mobi-ui-form-message-major level="error">
        {{
          'wfa_postal_city_incomplete'
            | texts
              : {
                  context: 'errors',
                  default:
                    'Bitte wählen Sie eine Postleitzahl und einen Ort aus der Liste.',
                }
        }}
      </mobi-ui-form-message-major>
    }
    @if (
      parentForm.get(key)?.hasError('xssContent') &&
      !parentForm.get(key)?.hasError('required') &&
      parentForm.get(key)?.touched
    ) {
      <mobi-ui-form-message-major level="error">
        @if (key === postalCityId) {
          {{
            'wfa_postal_city_xss'
              | texts
                : {
                    context: 'errors',
                    default:
                      'Bitte geben Sie eine gültige Postleitzahl oder einen Ort ohne HTML- oder Skript-Inhalte ein.',
                  }
          }}
        }
        @if (key === addressId) {
          {{
            'wfa_address_xss'
              | texts
                : {
                    context: 'errors',
                    default:
                      'Bitte geben Sie eine gültige Strasse ohne HTML- oder Skript-Inhalte ein.',
                  }
          }}
        }
        @if (key === address2Id) {
          {{
            'wfa_building_number_xss'
              | texts
                : {
                    context: 'errors',
                    default:
                      'Bitte geben Sie eine gültige Hausnummer ohne HTML- oder Skript-Inhalte ein.',
                  }
          }}
        }
      </mobi-ui-form-message-major>
    }
  }
</div>
